module.exports = __webpack_public_path__ + "img/zd-up-5.dbcca953.svg";